import type { ReactNode } from "react";

// SectionHead — the one "header of a section within a page" component.
// Promoted from Settings.tsx's local helper (S-687): Settings was the only
// screen with a shared section-header component; everywhere else that
// labels a sub-section defines its own class, landing anywhere from 14px to
// 19px with no shared source. This is the canonical size (18px, Settings'
// own — the most-established convention, already reused across every
// Settings section).
export interface SectionHeadProps {
  id?: string;
  title: ReactNode;
  /** Omit to drop the "Preview · S-095x" badge — used once a section's
   *  backend is wired. */
  story?: string;
  /** A full-width description line below the title row (Settings' original
   *  shape). Omit for a compact single-row header — title + trailing
   *  `action` metadata, nothing below (Atlas / IndexHealth / StudioAgents /
   *  Classification / BriefDetail's shape). */
  sub?: ReactNode;
  action?: ReactNode;
}

export function SectionHead({
  id,
  title,
  story,
  sub,
  action,
}: SectionHeadProps): JSX.Element {
  return (
    <>
      <div className="ds-section-head" id={id}>
        <h2>{title}</h2>
        <div className="ds-section-head__right">
          {story !== undefined && (
            <span className="ds-section-head__badge">Preview · {story}</span>
          )}
          {action}
        </div>
      </div>
      {sub !== undefined && <div className="ds-section-head__sub">{sub}</div>}
    </>
  );
}
